import { MultiBubbleIcon, PhonePausedIcon, ReportsIcon, UserCircleSvgIcon } from '@zeta-core/assets';

import { RouterLinks } from '../app-route-paths';

export const ADVISOR_ONBOARDING = {
  title: 'Profile Set-up',
  description: 'Please provide details on the type of financial advice you are seeking.',
  steps: [
    { label: 'Personal Details', value: 'personalDetails', route: RouterLinks.personalDetails },
    { label: 'Expertise Details', value: 'expertiseDetails', route: RouterLinks.expertiseDetails },
    { label: 'Qualification', value: 'qualifications', route: RouterLinks.qualifications },
    { label: 'Accolades Upload', value: 'accoladesUpload', route: RouterLinks.accoladesUpload },
    { label: 'Working Preferences', value: 'workingPreferences', route: RouterLinks.workingPreferences },
    { label: 'Client Data', value: 'clientData', route: RouterLinks.clientData },
    { label: 'Calendar Set-up', value: 'calendarSetUp', route: RouterLinks.calenderSetup },
    { label: 'Notifications', value: 'notifications', route: RouterLinks.notifications },
    { label: 'Terms & Conditions', value: 'termsAndConditions', route: RouterLinks.termsAndConditions },
  ],
};

export const ADVISOR_NAV_DATA = [
  { label: 'Advice', path: RouterLinks.advisorCopilot, icon: PhonePausedIcon },
  { label: 'Clients', path: RouterLinks.clients, icon: UserCircleSvgIcon },
  { label: 'Secured Messages', path: RouterLinks.securedMessages, icon: MultiBubbleIcon },
  { label: 'Reporting', path: RouterLinks.reporting, icon: ReportsIcon },
];

export const ROUTE_TO_FEATURE_MAP = {
  // Map from store feature keys to routes and conditions
  AdvisorDashboard: {
    routes: [RouterLinks.dashboard, RouterLinks.dashboardLink, RouterLinks.advisorCopilot, RouterLinks.clients],
    // No status conditions for dashboard
  },
  'Advisor-Client-List-View': {
    routes: [RouterLinks.clients],
  },
  'Advisor-Client-Create': {
    routes: [RouterLinks.inviteClient],
  },
  'Advisor-Client-Task': {
    routes: [RouterLinks.clientInfoWorkplaceTasksActivities],
  },
  // AIInteraction: {
  //   routes: [RouterLinks.askAi, RouterLinks.askZeta, RouterLinks.agentsConsumerDuty, RouterLinks.agentsIllustrations],
  // },
  'Advisor-Client-AI': {
    routes: [RouterLinks.advisorCopilot],
    Discovery: [RouterLinks.advisorCopilot],
    Advice: [RouterLinks.advisorCopilot],
    Recommendation: [RouterLinks.advisorCopilot],
    Managed: [RouterLinks.advisorCopilot],
  },
  'Advisor-Client-Recommendation-Summary': {
    routes: [RouterLinks.clientInfoWorkplaceRecommendation, RouterLinks.clientInfoWorkplacePlansNew, RouterLinks.clientInfoWorkplacePlansSetup],
  },
  // 'Advisor-Client-AMLKYC': {
  //   default: [RouterLinks.clientInfoKYCAML],
  //   Discovery: [RouterLinks.clientInfoKYCAML],
  //   Advice: [RouterLinks.clientInfoKYCAML],
  //   Recommendation: [RouterLinks.clientInfoKYCAML],
  // },
  // 'Advisor-Client-Document': {
  //   default: [RouterLinks.clientInfoDocuments, RouterLinks.clientInfoBilling],
  //   Discovery: [RouterLinks.clientInfoDocuments, RouterLinks.factFindDocuments],
  //   Advice: [RouterLinks.clientInfoDocuments, RouterLinks.clientInfoBilling],
  //   Recommendation: [RouterLinks.clientInfoDocuments, RouterLinks.clientInfoBilling],
  //   Managed: [RouterLinks.clientInfoDocuments, RouterLinks.managedClientDocuments, RouterLinks.clientInfoBilling],
  // },
  // 'Advisor-Client-Interaction-Timeline': {
  //   default: [RouterLinks.clientInfoClientInteractionHub],
  //   Discovery: [RouterLinks.clientInfoClientInteractionHub],
  //   Advice: [RouterLinks.clientInfoClientInteractionHub],
  //   Recommendation: [RouterLinks.clientInfoClientInteractionHub],
  //   Managed: [RouterLinks.managedClientInteractionHub],
  // },
  'Advisor-Client-FinancialPlan': {
    Managed: [RouterLinks.managedClientInvestmentSolution, RouterLinks.managedClientProtectionSolution, RouterLinks.managedClientRetirementPlanning],
  },
  // 'Advisor-Client-Message': {
  //   default: [RouterLinks.clientInfoSecureMessage],
  //   Discovery: [RouterLinks.clientInfoSecureMessage],
  //   Advice: [RouterLinks.clientInfoSecureMessage],
  //   Recommendation: [RouterLinks.clientInfoSecureMessage],
  //   Managed: [RouterLinks.managedClientSecureMessage],
  // },
  'Advisor-Client-Portfolio': {
    Managed: [RouterLinks.managedClientPortfolio, RouterLinks.managedClientPortfolioDetail],
  },
  'Advisor-Client-Summary': {
    Discovery: [],
    Advice: [],
    Recommendation: [],
  },
  'Advisor-Client-Workflow': {
    Discovery: [RouterLinks.factFindNextSteps],
    Advice: [],
    Recommendation: [],
  },
  'Advisor-Client-Cash-Protection-Tool': {
    Discovery: [RouterLinks.clientInfoprotectionPlanningSolution],
    Advice: [RouterLinks.clientInfoprotectionPlanningSolution],
    Recommendation: [RouterLinks.clientInfoprotectionPlanningSolution],
    Managed: [RouterLinks.clientInfoprotectionPlanningSolution],
  },
  AdvisorMPS: {
    routes: [RouterLinks.mps, RouterLinks.mpsRebalancing, RouterLinks.managePortfolio],
  },
  AdvisorMeeting: {
    routes: [RouterLinks.meetings, RouterLinks.availability],
  },
  AdvisorNotification: {
    routes: [RouterLinks.notifications, RouterLinks.notificationsProfileSetup],
  },
  AdvisorOrgConfig: {
    routes: [
      RouterLinks.profileSetup,
      RouterLinks.organisationProfile,
      RouterLinks.userManagement,
      RouterLinks.myProfile,
      RouterLinks.modelPortfolios,
      RouterLinks.riskAssessment,
      RouterLinks.financialPlanning,
      RouterLinks.adviceTemplates,
      RouterLinks.factFindConfiguration,
      RouterLinks.clientCommunication,
      RouterLinks.crm,
      RouterLinks.certificationsAndExpertise,
      RouterLinks.billingAndInvoice,
      RouterLinks.meetingConfiguration,
    ],
  },
  AdvisorTaskWorkflow: {
    routes: [
      RouterLinks.myTasks,
      RouterLinks.clientTasks,
      RouterLinks.createSolution,
      RouterLinks.report,
      RouterLinks.taskRTQ,
      RouterLinks.taskGDPR,
      // Planning task routes
      RouterLinks.clientInfofinancialPlanningTask,
      RouterLinks.clientInfoinvestmentPlanning,
      RouterLinks.clientInfoprotectionPlanning,
      RouterLinks.clientInfocustomTask,
      RouterLinks.protectionPlanning,
      RouterLinks.protectionPlanningSolution,
      RouterLinks.customTask,
      RouterLinks.clientInfofactFindTasks,
    ],
  },
  AiDiscovery: {
    routes: [RouterLinks.clientInfoAdvisoryActions],
  },
  ConversationalDiscovery: {
    routes: [RouterLinks.clientInfoAdvisoryActions],
    // AI page
  },
  HouseholdModeling: {
    routes: [RouterLinks.clientInfoHouseHold, RouterLinks.clientInfoAdvisoryActions, RouterLinks.clientInfoConflictResolution],
  },
  SecureDocumentStorage: {
    routes: [RouterLinks.clientInfoDocuments],
  },
  ClientDocumentExchange: {
    routes: [],
    // request document from client
  },
  DocumentAssistant: {
    routes: [RouterLinks.askAi, RouterLinks.askZeta, RouterLinks.agentsIllustrations],
  },
  ParaplanningAssistance: {
    routes: [
      RouterLinks.clientInfoPlans,
      RouterLinks.clientInfoReports,
      RouterLinks.clientInfoFinancialPlanningWorkspace,
      RouterLinks.clientInfoWorkplacePlansNew,
      RouterLinks.clientInfoWorkplacePlansSetup,
      RouterLinks.clientInfoWorkplaceReview,
    ],
  },
  FactFindTraceability: {
    routes: [RouterLinks.clientInfoClientInteractionHub],
  },
  ConsumerDutyEngine: {
    routes: [RouterLinks.agentsConsumerDuty, RouterLinks.complianceReviews, RouterLinks.complianceNewReview, RouterLinks.complianceReviewDetails],
  },
  SecureMessaging: {
    routes: [RouterLinks.clientInfoSecureMessage],
  },
  CaseTracking: {
    routes: [RouterLinks.clientInfoKYCAML],
  },
};

// Category to Routes Mapping based on subscription plan categories
export const CATEGORY_TO_ROUTES_MAP: Record<string, string[]> = {
  'Discovery, Fact-Find & AI Capture': [
    RouterLinks.clientInfoAdvisoryActions,
    RouterLinks.clientInfoprotectionPlanningSolution,
    RouterLinks.clientInfocustomTask,
    RouterLinks.clientInfoprotectionPlanning,
    RouterLinks.clientInfofinancialPlanningTask,
    RouterLinks.clientInfoinvestmentPlanning,
    RouterLinks.clientInfoinvestmentPlanningSummary,
    RouterLinks.clientInfoGoalsAndTimeline,
    RouterLinks.clientInfoKYCAML,
    RouterLinks.clientInfoClientInteractionHub,
  ],
  'Documents & AI Assistance': [RouterLinks.clientInfoDocuments],
  'Client 360° & Financial Visibility': [RouterLinks.clientInfoHouseHold, RouterLinks.clientInfoAdvisoryActions, RouterLinks.clientInfoConflictResolution],
  'Paraplanning & Suitability': [
    RouterLinks.clientInfoPlans,
    RouterLinks.clientInfoFinancialPlanningWorkspace,
    RouterLinks.clientInfoWorkplaceRecommendation,
    RouterLinks.clientInfoWorkplaceParaplanning,
    RouterLinks.clientInfoWorkplacePlansNew,
    RouterLinks.clientInfoWorkplacePlansSetup,
    RouterLinks.clientInfoWorkplaceReview,
  ],
  'Consumer Duty & Governance': [
    RouterLinks.complianceReviews,
    RouterLinks.complianceNewReview,

    RouterLinks.agentsConsumerDuty,
    RouterLinks.documentManagement,
    RouterLinks.clientInfoDocuments,
    RouterLinks.factFindDocuments,
    RouterLinks.askAi,
    RouterLinks.askZeta,
    RouterLinks.complianceReviewDetails,
  ],
  'Platform & Workflow': [
    RouterLinks.advisorCopilot,
    RouterLinks.clients,
    RouterLinks.clientInfo,
    RouterLinks.meetings,
    RouterLinks.availability,
    RouterLinks.notifications,
    RouterLinks.notificationsProfileSetup,
    RouterLinks.clientInfoSecureMessage,
    RouterLinks.managedClientSecureMessage,
    RouterLinks.clientInfoClientInteractionHub,
    RouterLinks.managedClientInteractionHub,
    RouterLinks.inviteClient,
    RouterLinks.migrateClient,
    RouterLinks.mps,
    RouterLinks.mpsRebalancing,
    RouterLinks.managePortfolio,
    RouterLinks.crm,
    RouterLinks.modelPortfolios,
  ],
  default: [
    RouterLinks.dashboard,
    RouterLinks.advisorCopilot,
    RouterLinks.clientInfoHouseHold,
    RouterLinks.clientInfoDocuments,
    RouterLinks.dashboardLink,
    RouterLinks.clients,
    RouterLinks.notifications,
    RouterLinks.myTasks,
    RouterLinks.inviteClient,
    RouterLinks.userManagement,
    RouterLinks.adviceTemplates,
    RouterLinks.taskRTQ,
    RouterLinks.taskGDPR,
    RouterLinks.clientInfofactFindTasks,
    RouterLinks.paymentSuccess,
    RouterLinks.support,
    RouterLinks.meetings,
  ],
};
